
import Vue from 'vue';
import { isWeiXin } from '@/common/ts/common';
import { getBaseInfo } from './api';

export default Vue.extend({
  data() {
    return {
      baseInfo: {} as any,
    };
  },
  computed: {
    isScorePage(): boolean {
      return this.$route.path.indexOf('/score') > -1;
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.handleRouteChange();
      },
    },
  },
  async created() {
    const ret = await getBaseInfo();
    console.log('ret: ', ret);
    this.baseInfo = ret.data;
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  },
  methods: {
    handleRouteChange() {
      const cover =
        'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
      this.$appShareInfo({
        title: '2026美加墨世界杯积分榜',
        url: location.href,
        subtitle: '',
        classId: -1,
        id: -1,
        image: cover,

        type: 3,
      });
      if (!isWeiXin()) {
        return;
      }
      this.$wxShareInfo({
        title: '2026美加墨世界杯积分榜',
        subtitle: '',
        image: cover,
      });
    },
    handleScoreClick() {
      this.$router.push({
        path: '/20260609MMSJB/score',
      });
    },
  },
});
